import {
  DocumentNode,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
} from '@apollo/client';

import { useGraphql } from '@sbu/contexts.graphql';
import {
  MutationOptions,
  useMutation as useMutationOriginal,
} from '@sbu/hooks.graphql';

export const useMutation = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables> & MutationOptions
): MutationTuple<TData, TVariables> => {
  const { enableSplitHttpLink } = useGraphql();

  let refetchQueries = options?.refetchQueries || [];
  if (options?.refetchQueries?.length) {
    if (Array.isArray(options.refetchQueries)) {
      refetchQueries = options.refetchQueries.map((query) => {
        if (typeof query === 'string') {
          return query;
        }
        return {
          ...query,
          context: {
            targetGraph: 'ADMIRAL',
            enableSplitHttpLink,
          },
        };
      });
    }
  }

  return useMutationOriginal(mutation, {
    ...options,
    context: {
      ...options?.context,
      targetGraph: 'ADMIRAL',
      enableSplitHttpLink,
    },
    refetchQueries,
  });
};
